import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: 0,
  discountrate: 0,
  discountcode: "0",
  discounttype: "[NO DISCOUNT]",
  customerticket: "new",
  transactiondate: "",
  closed: true,
};

export const salesSlice = createSlice({
  name: "sales",
  initialState,
  reducers: {
    setSales: (state, action) => {
      state.value = action.payload;
    },
    getTotalSales: (state, action) => {
      state.value = action.payload;
    },
    setDiscountRate: (state, action) => {
      state.discountrate = action.payload;
    },
    getDiscountRate: (state, action) => {
      state.discountrate = action.payload;
    },
    setDiscountCode: (state, action) => {
      state.discountcode = action.payload;
    },
    getDiscountCode: (state, action) => {
      state.discountcode = action.payload;
    },
    setDiscountType: (state, action) => {
      state.discounttype = action.payload;
    },
    getDiscountType: (state, action) => {
      state.discounttype = action.payload;
    },
    setCustomerTicket: (state, action) => {
      state.customerticket = action.payload;
    },
    getCustomerTicket: (state, action) => {
      state.customerticket = action.payload;
    },
    setTransactionDate: (state, action) => {
      state.transactiondate = action.payload;
    },
    getTransactionDate: (state, action) => {
      state.transactiondate = action.payload;
    },
    setStatus: (state, action) => {
      state.closed = action.payload;
    },
    getStatus: (state, action) => {
      state.closed = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSales,
  getTotalSales,
  setDiscountRate,
  getDiscountRate,
  setDiscountCode,
  getDiscountCode,
  setDiscountType,
  getDiscountType,
  setCustomerTicket,
  getCustomerTicket,
  setTransactionDate,
  getTransactionDate,
  setStatus,
  getStatus,
} = salesSlice.actions;

export default salesSlice.reducer;
